import React from 'react';
import { Navigate } from 'react-router-dom';
import { ANALYZE_PAGE } from 'data/consts/routes';

export default function HomePage() {
    return <Navigate replace to={ANALYZE_PAGE} />;
}
